module.exports = __webpack_public_path__ + "img/20220326_171331.2e383f54.jpg";